var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56661 5.5725L3.52661 15.97L8.09911 14.25L12.6716 16L8.56661 5.5725ZM7.29161 1.915C7.29161 1.49 7.25161 1.06 7.23161 0.665H7.25411L7.68661 1.4975L9.15661 4.0425H9.67911V0H9.19661V2.0975C9.19661 2.515 9.23411 2.965 9.26411 3.375H9.23411L8.79911 2.5425L7.33411 0H6.81161V4.0325H7.29661L7.29161 1.915Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.4171c6c3a5d522906b74448c00e9857e.svg";
export { ForwardRef as ReactComponent };